var React = require('react');

function MapOptionsSelected (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"4","y":"4","width":"24","height":"24","rx":"12","fill":"#E57710","key":0}),React.createElement("path",{"d":"M16 23.3335L9 17.8946L10.0484 17.0895L16 21.697L21.9516 17.0895L23 17.8946L16 23.3335ZM16 19.5444L9 14.1055L16 8.66638L23 14.1055L16 19.5444Z","fill":"white","key":1})]);
}

MapOptionsSelected.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = MapOptionsSelected;

MapOptionsSelected.default = MapOptionsSelected;
